import { useEffect, useState } from "react";
import { Target } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export const WinRates = () => {
  const { t } = useLang();
  const w = t.dash.winRates;
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/stats/win-rates").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const label = (col, key) =>
    col === "sources" ? (key === "chat" ? w.chat : w.form) : col === "interests" ? t.form.options[key] || key : key;
  const cols = [
    ["sources", w.sources],
    ["interests", w.interests],
    ["packs", w.packs],
  ];

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="win-rates-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-6">
        <Target className="w-4 h-4 text-[#FF7900]" /> {w.title}
      </p>
      <div className="grid md:grid-cols-3 gap-8">
        {cols.map(([key, title]) => (
          <div key={key}>
            <p className="text-[11px] uppercase tracking-widest text-white/30 mb-3">{title}</p>
            {data[key].length === 0 && <p className="text-xs text-white/30">{w.empty}</p>}
            {data[key].map((r) => (
              <div key={r.key} className="mb-3" data-testid={`win-rate-${key}-row`}>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-white/70 truncate pr-2">{label(key, r.key)}</span>
                  <span className="text-white/40 shrink-0">
                    {r.converted}/{r.total} · <span className="text-emerald-400 font-semibold">{r.rate}%</span>
                  </span>
                </div>
                <div className="h-1 bg-white/5">
                  <div className="h-1 bg-emerald-500 transition-[width] duration-500" style={{ width: `${r.rate}%` }} />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
